import {forEach} from 'lodash'
import MyEventsCalculation from '../../components/MyEventsCalculation.vue'
import MyEventsContainer from '../../components/MyEventsContainer.vue'
import { loading } from '../../core/page-loader'
import { modalClose } from "../../utility"


new Vue({
    el: '#my-events',
    name: 'MyEvents',
    components: {
        MyEventsCalculation, MyEventsContainer
    },
    data() {
        return {
            calculations: [],
            containers:[],
            options:  [],
            value: null
        }
    },
    mounted: function() {
        this.fetchData()
        this.$el.style.visibility = 'visible'

        this.$event.$on('pdf-created', () => {
            this.fetchData()
        })
    },
    methods: {
        fetchData() {
            loading(true)
            axios.get('/calculation/index').then((response) => {
                loading(false)
                this.calculations = response.data.calculations
                this.containers = response.data.containers
                this.setContainerSelectorOptions()
            }).catch((error) => {
                loading(false)
                console.error('error in MyEvents', error)
            })
        },
        callCrateContainerModal() {
            let nameModal = $('#container-name-modal'),
                nameInput = $('#container-name-input'),
                nameConfirm = $('#name-container-confirm'),
                closeIconsModal = $('.modal-close', nameModal)

            nameInput.val('neue Gruppe')

            nameConfirm.one('click', () => {
                let name = nameInput.val()
                this.createContainer(name)

                modalClose()

                nameConfirm.off()
                closeIconsModal.off()
            })

            closeIconsModal.on('click', () => {
                nameConfirm.off()
                closeIconsModal.off()
            })

            nameModal.addClass('active')
        },
        createContainer(name) {
            $('#container-name-modal').addClass('is-loading')

            loading(true)
            axios.post('/calculation/container/store', {
                name: name
            }).then((response) => {
                $('#container-name-modal').removeClass('is-loading')
                this.fetchData()
            })
        },
        setContainerSelectorOptions() {
            let options = ""
            forEach(this.containers, function (value) {
                options = options + `<option value="${value.id}">${value.name}</option>`
            })

            $('#calculation-container-selector').html(options)
        }
    },
})